// REST API & pg_tileserv
var { api_url, pg_tileserv_url } = require("./settings-server");

// Languages
const defaultLanguage = "es";
const defaultLocaleFormatNumber = "fr";

const config = {
  defaultLanguage: defaultLanguage,
  defaultLocaleFormatNumber: defaultLocaleFormatNumber,
  home: {
    title: `homeTitle`,
    speech: `homeSpeech`,
    help: `homeHelp`,
  },
  cities: {
    cusco: {
      center: [-71.92, -80.93863],
      zoom: 8,
      extent: [-8100000, -1600000, -7930000, -1430000],
    },
  },
  citiesDetails: [
    {
      label: "Cusco",
      id: "cusco",
      dbId: "",
    },
    {
      label: "Quispicanchi",
      id: "quispicanchi",
      dbId: "_quispicanchi",
    },
    {
      label: "Anta",
      id: "anta",
      dbId: "_anta",
    },
    {
      label: "Urubamba",
      id: "urubamba",
      dbId: "_urubamba",
    },
  ],
  displayTabs: {
    displayTabMobilityIndicators: true,
    displayTabSumpTrajectory: true,
    displayTabSumpManagement: true,
    displayTabDigitalParticipation: true,
    displayTabReferences: true,
    displayExternalLink: true,
  },
  externalLinks: [
    {
      label: "GoodVision",
      link: "https://my.goodvisionlive.com/en/login",
      logo: require("./img/logo_goodvision.png"),
    },
    {
      label: "Tera Analytics",
      link: "https://data.atmotrack.fr/fr/dvdh-cusco-307/home",
      logo: require("./img/logo_tera_analytics.png"),
    },
  ],
  years: ["2011", "2015", "2022"],
  geographicalAreas: {
    "Provincia de Cusco": "Provincia de Cusco",
    "Provincia de Quispicanchi": "Provincia de Quispicanchi",
    "Provincia de Anta": "Provincia de Anta",
    "Provincia de Urubamba": "Provincia de Urubamba",
    "area metropolitana": "area metropolitana",
  },
  // https://materialui.co/flatuicolors/
  // https://materialui.co/colors
  charts: {
    xAxisMinYearMobilityIndicators: 2011,
    xAxisMaxYearMobilityIndicators: 2022,
    xAxisMinYearSumpTrajectory: 2011,
    xAxisMaxYearSumpTrajectory: 2050,
    maxRadiusMapPie: 30,
    colorPalettes: {
      // Geographical areas : Provincia de Cusco, Provincia de Quispicanchi, Provincia de Anta, Provincia de Urubamba, area metropolitana
      0: {
        backgroundColor: [
          "rgb(115, 152, 99)",
          "rgb(204, 112, 65)",
          "rgb(39, 64, 103)",
          "rgb(220, 174, 77)",
          "rgb(160, 119, 142)",
        ],
        borderColor: [
          "rgb(115, 152, 99)",
          "rgb(204, 112, 65)",
          "rgb(39, 64, 103)",
          "rgb(220, 174, 77)",
          "rgb(160, 119, 142)",
        ],
        borderWidth: 1,
      },
      // Opacity (PartActifsHabitants indicator)
      "0_opacity_part_actifs_habitants": {
        backgroundColor: [
          "rgb(115, 152, 99)",
          "rgb(204, 112, 65)",
          "rgb(39, 64, 103)",
          "rgb(220, 174, 77)",
          "rgb(160, 119, 142)",
        ],
        borderColor: [
          "rgb(115, 152, 99)",
          "rgb(204, 112, 65)",
          "rgb(39, 64, 103)",
          "rgb(220, 174, 77)",
          "rgb(160, 119, 142)",
        ],
        borderWidth: 1,
      },
      // Colors transmitted notably for the modal split chart
      // Other were added for cartographic needs
      1: {
        backgroundColor: [
          "rgba(255, 200, 0, 0.4)",
          "rgba(0, 176, 80, 0.4)",
          "rgba(250, 50, 150, 0.4)",
          "rgba(63, 184, 216, 0.4)",
          "rgba(152, 46, 132, 0.4)",
          "rgba(146, 208, 80, 0.4)",
          "rgba(189, 0, 38, 0.4)",
          "rgba(127, 141, 244, 0.4)",
          "rgba(254, 168, 47, 0.4)",
        ],
        borderColor: [
          "rgb(255, 200, 0)",
          "rgb(0, 176, 80)",
          "rgb(250, 50, 150)",
          "rgb(63, 184, 216)",
          "rgb(152, 46, 132)",
          "rgb(146, 208, 80)",
          "rgb(189, 0, 38)",
          "rgb(127, 141, 244)",
          "rgb(254, 168, 47)",
        ],
        borderWidth: 1,
      },
      // Transport Public : vitesse commerciale et fréquentation
      2: {
        backgroundColor: ["rgb(0, 176, 240)", "rgb(0, 32, 96)"],
        borderColor: ["rgb(0, 176, 240)", "rgb(0, 32, 96)"],
        borderWidth: 1,
      },
      // Motorisation
      3: {
        backgroundColor: ["rgb(216, 109, 205)", "rgb(242, 206, 239)"],
        borderColor: ["rgb(216, 109, 205)", "rgb(242, 206, 239)"],
        borderWidth: 1,
      },
      // Motorisation
      4: {
        backgroundColor: ["rgb(167, 0, 30)", "rgb(255, 189, 189)"],
        borderColor: ["rgb(167, 0, 30)", "rgb(255, 189, 189)"],
        borderWidth: 1,
      },
      // Répartition modale des déplacements quotidiens
      5: {
        backgroundColor: [
          "rgb(0, 176, 80)",
          "rgb(146, 208, 80)",
          "rgb(242, 206, 239)",
          "rgb(216, 109, 205)",
          "rgb(255, 192, 0)",
          "rgb(0, 176, 240)",
          "rgb(33, 92, 152)",
          "rgb(0, 32, 96)",
          "rgb(202, 237, 251)",
          "rgb(148, 220, 248)",
          "rgb(247, 199, 172)",
          "rgb(255, 255, 0)",
        ],
        borderColor: [
          "rgb(0, 176, 80)",
          "rgb(146, 208, 80)",
          "rgb(242, 206, 239)",
          "rgb(216, 109, 205)",
          "rgb(255, 192, 0)",
          "rgb(0, 176, 240)",
          "rgb(33, 92, 152)",
          "rgb(0, 32, 96)",
          "rgb(202, 237, 251)",
          "rgb(148, 220, 248)",
          "rgb(247, 199, 172)",
          "rgb(255, 255, 0)",
        ],
        borderWidth: 1,
      },
      // Emissions CO2
      6: {
        backgroundColor: [
          "rgb(0, 176, 240)",
          "rgb(255, 192, 0)",
          "rgb(216, 109, 205)",
          "rgb(242, 206, 239)",
        ],
        borderColor: [
          "rgb(0, 176, 240)",
          "rgb(255, 192, 0)",
          "rgb(216, 109, 205)",
          "rgb(242, 206, 239)",
        ],
        borderWidth: 1,
      },
      // Budget transports
      7: {
        backgroundColor: ["rgb(247, 199, 172)"],
        borderColor: ["rgb(247, 199, 172)"],
        borderWidth: 1,
      },
      // Taux immobilite
      8: {
        backgroundColor: ["rgb(255, 255, 255)", "rgb(210, 180, 140)"],
        borderColor: ["rgb(210, 180, 140)", "rgb(210, 180, 140)"],
        borderWidth: 1,
      },
      // Taux Mobilite Quotidien (femme/homme)
      9: {
        backgroundColor: ["rgb(255, 255, 255)", "rgb(189, 195, 199)"],
        borderColor: ["rgb(189, 195, 199)", "rgb(189, 195, 199)"],
        borderWidth: 1,
      },
      // Undefined : missing attribute in popup
      undefined: {
        backgroundColor: ["rgba(149, 165, 166, 0.8)"],
        borderColor: ["rgb(149, 165, 166)"],
        borderWidth: 1,
      },
      // Transparent
      transparent: {
        backgroundColor: ["rgba(0, 0, 0, 0)"],
        borderColor: ["rgba(0, 0, 0, 0)"],
        borderWidth: 0,
      },
      // White
      white: {
        backgroundColor: ["rgba(255, 255, 255, 1)"],
        borderColor: ["rgba(255, 255, 255, 1)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2040
      trajectory_target_value_2040: {
        backgroundColor: ["rgb(7, 153, 146)"],
        borderColor: ["rgb(7, 153, 146)"],
        borderWidth: 0,
      },
      // Trajectory : VolumeDeplacementsJournaliersMode indicator
      trajectory_volume_deplacements_journaliers_mode: {
        backgroundColor: [
          "rgb(216, 110, 204)",
          "rgb(255, 192, 0)",
          "rgb(255, 220, 109)",
          "rgb(16, 72, 98)",
          "rgb(70, 177, 225)",
          "rgb(193, 229, 245)",
          "rgb(0, 176, 80)",
          "rgb(146, 208, 80)",
          "rgb(174, 174, 174)",
        ],
        borderColor: [
          "rgb(216, 110, 204)",
          "rgb(255, 192, 0)",
          "rgb(255, 220, 109)",
          "rgb(16, 72, 98)",
          "rgb(70, 177, 225)",
          "rgb(193, 229, 245)",
          "rgb(0, 176, 80)",
          "rgb(146, 208, 80)",
          "rgb(174, 174, 174)",
        ],
        borderWidth: 0,
      },
      // Trajectory : VolumeDeplacementsJournaliersMode indicator (objective -> with transparency)
      trajectory_volume_deplacements_journaliers_mode_objective_transparency: {
        backgroundColor: [
          "rgba(216, 110, 204, 0.4)",
          "rgba(255, 192, 0, 0.4)",
          "rgba(255, 220, 109, 0.4)",
          "rgba(16, 72, 98, 0.4)",
          "rgba(70, 177, 225, 0.4)",
          "rgba(193, 229, 245, 0.4)",
          "rgba(0, 176, 80, 0.4)",
          "rgba(146, 208, 80, 0.4)",
          "rgba(174, 174, 174, 0.4)",
        ],
        borderColor: [
          "rgba(216, 110, 204, 0.4)",
          "rgba(255, 192, 0, 0.4)",
          "rgba(255, 220, 109, 0.4)",
          "rgba(16, 72, 98, 0.4)",
          "rgba(70, 177, 225, 0.4)",
          "rgba(193, 229, 245, 0.4)",
          "rgba(0, 176, 80, 0.4)",
          "rgba(146, 208, 80, 0.4)",
          "rgba(174, 174, 174, 0.4)",
        ],
        borderWidth: 0,
      },
      // Trajectory : EvolutionPartModaleDeplacementsQuotidiens indicator
      trajectory_evolution_part_modale_deplacements_quotidiens: {
        backgroundColor: [
          "rgb(216, 109, 205)",
          "rgb(255, 192, 0)",
          "rgb(0, 176, 240)",
          "rgb(146, 208, 80)",
          "rgb(0, 176, 80)",
          "rgb(174, 174, 174)",
        ],
        borderColor: [
          "rgb(216, 109, 205)",
          "rgb(255, 192, 0)",
          "rgb(0, 176, 240)",
          "rgb(146, 208, 80)",
          "rgb(0, 176, 80)",
          "rgb(174, 174, 174)",
        ],
        borderWidth: 0,
      },
      // Trajectory : EvolutionPartModaleDeplacementsQuotidiens indicator (objective -> with transparency)
      trajectory_evolution_part_modale_deplacements_quotidiens_objective_transparency:
        {
          backgroundColor: [
            "rgba(216, 109, 205, 0.4)",
            "rgba(255, 192, 0, 0.4)",
            "rgba(0, 176, 240, 0.4)",
            "rgba(146, 208, 80, 0.4)",
            "rgba(0, 176, 80, 0.4)",
            "rgba(174, 174, 174, 0.4)",
          ],
          borderColor: [
            "rgba(216, 109, 205, 0.4)",
            "rgba(255, 192, 0, 0.4)",
            "rgba(0, 176, 240, 0.4)",
            "rgba(146, 208, 80, 0.4)",
            "rgba(0, 176, 80, 0.4)",
            "rgba(174, 174, 174, 0.4)",
          ],
          borderWidth: 0,
        },
      // Trajectory : EvolutionTauxMobilite indicator
      trajectory_evolution_taux_mobilite: {
        backgroundColor: ["rgb(247, 199, 172)"],
        borderColor: ["rgb(247, 199, 172)"],
        borderWidth: 0,
      },
      // Trajectory : EvolutionTauxMobilite indicator (objective -> with transparency)
      trajectory_evolution_taux_mobilite_objective_transparency: {
        backgroundColor: ["rgba(247, 199, 172, 0.4)"],
        borderColor: ["rgba(247, 199, 172, 0.4)"],
        borderWidth: 0,
      },
      // Trajectory : EvolutionTauxMotorisation indicator
      trajectory_evolution_taux_motorisation: {
        backgroundColor: ["rgb(216, 109, 205)", "rgb(242, 206, 239)"],
        borderColor: ["rgb(216, 109, 205)", "rgb(242, 206, 239)"],
        borderWidth: 0,
      },
      // Trajectory : EvolutionTauxMotorisation indicator (objective -> with transparency)
      trajectory_evolution_taux_motorisation_objective_transparency: {
        backgroundColor: [
          "rgba(216, 109, 205, 0.4)",
          "rgba(242, 206, 239, 0.4)",
        ],
        borderColor: ["rgba(216, 109, 205, 0.4)", "rgba(242, 206, 239, 0.4)"],
        borderWidth: 0,
      },
      // Trajectory : PartBudgetMoyenMobilite indicator
      trajectory_part_budget_moyen_mobilite: {
        backgroundColor: [
          "rgb(184, 233, 148)",
          "rgb(251, 227, 214)",
          "rgb(255, 216, 139)",
        ],
        borderColor: [
          "rgb(184, 233, 148)",
          "rgb(251, 227, 214)",
          "rgb(255, 216, 139)",
        ],
        borderWidth: 0,
      },
      // Trajectory : EmissionsCo2 indicator
      trajectory_emissions_co2: {
        backgroundColor: [
          "rgb(0, 32, 96)",
          "rgb(33, 92, 152)",
          "rgb(0, 176, 240)",
          "rgb(255, 192, 0)",
          "rgb(255, 255, 0)",
          "rgb(216, 109, 205)",
          "rgb(242, 206, 239)",
        ],
        borderColor: [
          "rgb(0, 32, 96)",
          "rgb(33, 92, 152)",
          "rgb(0, 176, 240)",
          "rgb(255, 192, 0)",
          "rgb(255, 255, 0)",
          "rgb(216, 109, 205)",
          "rgb(242, 206, 239)",
        ],
        borderWidth: 0,
      },
      // Trajectory : EmissionsCo2 indicator (objective -> with transparency)
      trajectory_emissions_co2_objective_transparency: {
        backgroundColor: [
          "rgba(0, 32, 96, 0.4)",
          "rgba(33, 92, 152, 0.4)",
          "rgba(0, 176, 240, 0.4)",
          "rgba(255, 192, 0, 0.4)",
          "rgba(255, 255, 0, 0.4)",
          "rgba(216, 109, 205, 0.4)",
          "rgba(242, 206, 239, 0.4)",
        ],
        borderColor: [
          "rgba(0, 32, 96, 0.4)",
          "rgba(33, 92, 152, 0.4)",
          "rgba(0, 176, 240, 0.4)",
          "rgba(255, 192, 0, 0.4)",
          "rgba(255, 255, 0, 0.4)",
          "rgba(216, 109, 205, 0.4)",
          "rgba(242, 206, 239, 0.4)",
        ],
        borderWidth: 0,
      },
      // Trajectory : target value 2024 voies prioritaires pietons
      trajectory_target_value_2024_voies_prioritaires_pietons: {
        backgroundColor: ["rgb(146, 208, 80)"],
        borderColor: ["rgb(146, 208, 80)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2034 voies prioritaires pietons
      trajectory_target_value_2034_voies_prioritaires_pietons: {
        backgroundColor: ["rgb(74, 214, 141)"],
        borderColor: ["rgb(74, 214, 141)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2044 voies prioritaires pietons
      trajectory_target_value_2044_voies_prioritaires_pietons: {
        backgroundColor: ["rgb(39, 171, 102)"],
        borderColor: ["rgb(39, 171, 102)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2024 infrastructures cyclables avenues
      trajectory_target_value_2024_infrastructures_cyclables_avenues: {
        backgroundColor: ["rgb(25, 107, 36)"],
        borderColor: ["rgb(25, 107, 36)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2034 infrastructures cyclables avenues
      trajectory_target_value_2034_infrastructures_cyclables_avenues: {
        backgroundColor: ["rgb(47, 163, 44)"],
        borderColor: ["rgb(47, 163, 44)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2044 infrastructures cyclables avenues
      trajectory_target_value_2044_infrastructures_cyclables_avenues: {
        backgroundColor: ["rgb(27, 95, 84)"],
        borderColor: ["rgb(27, 95, 84)"],
        borderWidth: 0,
      },
      // Trajectory : DureeMoyenneTrajet indicator
      trajectory_duree_moyenne_trajet: {
        backgroundColor: ["rgb(218, 28, 87)", "rgb(15, 158, 213)"],
        borderColor: ["rgb(218, 28, 87)", "rgb(15, 158, 213)"],
        borderWidth: 0,
      },
      // Trajectory : DureeMoyenneTrajet indicator (objective -> with transparency)
      trajectory_duree_moyenne_trajet_objective_transparency: {
        backgroundColor: ["rgba(218, 28, 87, 0.4)", "rgba(15, 158, 213, 0.4)"],
        borderColor: ["rgba(218, 28, 87, 0.4)", "rgba(15, 158, 213, 0.4)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2024 longueur voies transport public
      trajectory_target_value_2024_longueur_voies_transport_public: {
        backgroundColor: ["rgb(21, 96, 130)"],
        borderColor: ["rgb(21, 96, 130)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2034 longueur voies transport public
      trajectory_target_value_2034_longueur_voies_transport_public: {
        backgroundColor: ["rgb(174, 174, 174)"],
        borderColor: ["rgb(174, 174, 174)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2044 longueur voies transport public
      trajectory_target_value_2044_longueur_voies_transport_public: {
        backgroundColor: ["rgb(38, 38, 38)"],
        borderColor: ["rgb(38, 38, 38)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2024 longueur voies rapides
      trajectory_target_value_2024_longueur_voies_rapides: {
        backgroundColor: ["rgb(218, 28, 87)"],
        borderColor: ["rgb(218, 28, 87)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2034 longueur voies rapides
      trajectory_target_value_2034_longueur_voies_rapides: {
        backgroundColor: ["rgb(174, 174, 174)"],
        borderColor: ["rgb(174, 174, 174)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2044 longueur voies rapides
      trajectory_target_value_2044_longueur_voies_rapides: {
        backgroundColor: ["rgb(38, 38, 38)"],
        borderColor: ["rgb(38, 38, 38)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2024 taux couverture reseau transport urbain
      trajectory_target_value_2024_taux_couverture_reseau_transport_urbain: {
        backgroundColor: ["rgb(78, 149, 217)"],
        borderColor: ["rgb(78, 149, 217)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2034 taux couverture reseau transport urbain
      trajectory_target_value_2034_taux_couverture_reseau_transport_urbain: {
        backgroundColor: ["rgb(242, 170, 132)"],
        borderColor: ["rgb(242, 170, 132)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2044 taux couverture reseau transport urbain
      trajectory_target_value_2044_taux_couverture_reseau_transport_urbain: {
        backgroundColor: ["rgb(71, 212, 90)"],
        borderColor: ["rgb(71, 212, 90)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2024 femmes entreprises transport
      trajectory_target_value_2024_femmes_entreprises_transport: {
        backgroundColor: ["rgb(139, 141, 211)"],
        borderColor: ["rgb(139, 141, 211)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2034 femmes entreprises transport
      trajectory_target_value_2034_femmes_entreprises_transport: {
        backgroundColor: ["rgb(242, 170, 132)"],
        borderColor: ["rgb(242, 170, 132)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2044 femmes entreprises transport
      trajectory_target_value_2044_femmes_entreprises_transport: {
        backgroundColor: ["rgb(71, 212, 90)"],
        borderColor: ["rgb(71, 212, 90)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2024 accidents routes
      trajectory_target_value_2024_accidents_routes: {
        backgroundColor: ["rgb(210, 180, 140)"],
        borderColor: ["rgb(210, 180, 140)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2034 accidents routes
      trajectory_target_value_2034_accidents_routes: {
        backgroundColor: ["rgb(234, 168, 50)"],
        borderColor: ["rgb(234, 168, 50)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2044 accidents routes
      trajectory_target_value_2044_accidents_routes: {
        backgroundColor: ["rgb(70, 177, 225)"],
        borderColor: ["rgb(70, 177, 225)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2024 acces pmr tc
      trajectory_target_value_2024_acces_pmr_tc: {
        backgroundColor: ["rgb(235, 115, 175)"],
        borderColor: ["rgb(235, 115, 175)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2034 acces pmr tc
      trajectory_target_value_2034_acces_pmr_tc: {
        backgroundColor: ["rgb(229, 158, 221)"],
        borderColor: ["rgb(229, 158, 221)"],
        borderWidth: 0,
      },
      // Trajectory : target value 2044 acces pmr tc
      trajectory_target_value_2044_acces_pmr_tc: {
        backgroundColor: ["rgb(78, 149, 217)"],
        borderColor: ["rgb(78, 149, 217)"],
        borderWidth: 0,
      },
      // Trajectory : EmissionPm indicator
      trajectory_emission_pm: {
        backgroundColor: [
          "rgb(255, 192, 0)",
          "rgb(216, 109, 205)",
          "rgb(242, 206, 239)",
          "rgb(0, 176, 240)",
          "rgb(21, 96, 130)",
        ],
        borderColor: [
          "rgb(255, 192, 0)",
          "rgb(216, 109, 205)",
          "rgb(242, 206, 239)",
          "rgb(0, 176, 240)",
          "rgb(21, 96, 130)",
        ],
        borderWidth: 0,
      },
      // Trajectory : EmissionPm indicator (objective -> with transparency)
      trajectory_emission_pm_objective_transparency: {
        backgroundColor: [
          "rgba(255, 192, 0, 0.4)",
          "rgba(216, 109, 205, 0.4)",
          "rgba(242, 206, 239, 0.4)",
          "rgba(0, 176, 240, 0.4)",
          "rgba(21, 96, 130, 0.4)",
        ],
        borderColor: [
          "rgba(255, 192, 0, 0.4)",
          "rgba(216, 109, 205, 0.4)",
          "rgba(242, 206, 239, 0.4)",
          "rgba(0, 176, 240, 0.4)",
          "rgba(21, 96, 130, 0.4)",
        ],
        borderWidth: 0,
      },
      // Trajectory : EmissionCo2 indicator
      trajectory_emission_co2: {
        backgroundColor: [
          "rgb(255, 192, 0)",
          "rgb(216, 109, 205)",
          "rgb(242, 206, 239)",
          "rgb(0, 176, 240)",
          "rgb(21, 96, 130)",
        ],
        borderColor: [
          "rgb(255, 192, 0)",
          "rgb(216, 109, 205)",
          "rgb(242, 206, 239)",
          "rgb(0, 176, 240)",
          "rgb(21, 96, 130)",
        ],
        borderWidth: 0,
      },
      // Trajectory : EmissionCo2 indicator (objective -> with transparency)
      trajectory_emission_co2_objective_transparency: {
        backgroundColor: [
          "rgba(255, 192, 0, 0.4)",
          "rgba(216, 109, 205, 0.4)",
          "rgba(242, 206, 239, 0.4)",
          "rgba(0, 176, 240, 0.4)",
          "rgba(21, 96, 130, 0.4)",
        ],
        borderColor: [
          "rgba(255, 192, 0, 0.4)",
          "rgba(216, 109, 205, 0.4)",
          "rgba(242, 206, 239, 0.4)",
          "rgba(0, 176, 240, 0.4)",
          "rgba(21, 96, 130, 0.4)",
        ],
        borderWidth: 0,
      },
      // Trajectory : DureeMoyenneTrajetCuscoChinchero indicator
      trajectory_duree_moyenne_trajet_cusco_chinchero: {
        backgroundColor: ["rgb(0, 176, 240)", "rgb(216, 109, 205)"],
        borderColor: ["rgb(0, 176, 240)", "rgb(216, 109, 205)"],
        borderWidth: 0,
      },
      // Trajectory : DureeMoyenneTrajetCuscoChinchero indicator (objective -> with transparency)
      trajectory_duree_moyenne_trajet_cusco_chinchero_objective_transparency: {
        backgroundColor: ["rgba(0, 176, 240, 0.4)", "rgba(216, 109, 205, 0.4)"],
        borderColor: ["rgba(0, 176, 240, 0.4)", "rgba(216, 109, 205, 0.4)"],
        borderWidth: 0,
      },
      // Trajectory : DureeMoyenneTrajetCuscoUrcos indicator
      trajectory_duree_moyenne_trajet_cusco_urcos: {
        backgroundColor: ["rgb(0, 176, 240)", "rgb(216, 109, 205)"],
        borderColor: ["rgb(0, 176, 240)", "rgb(216, 109, 205)"],
        borderWidth: 0,
      },
      // Trajectory : DureeMoyenneTrajetCuscoUrcos indicator (objective -> with transparency)
      trajectory_duree_moyenne_trajet_cusco_urcos_objective_transparency: {
        backgroundColor: ["rgba(0, 176, 240, 0.4)", "rgba(216, 109, 205, 0.4)"],
        borderColor: ["rgba(0, 176, 240, 0.4)", "rgba(216, 109, 205, 0.4)"],
        borderWidth: 0,
      },
    },
  },
  gantt: {
    status: {
      Planifié: "#C2E3F4",
      "En cours de démarrage": "#ffec33",
      "En cours": "#EFB730",
      Suspendu: "#f39c12",
      Abandonné: "#F2F4EF",
      Achevé: "#75b99d",
    },
    yearEnd: 2045,
    widthYear: 58,
  },
};

module.exports = {
  api_url,
  pg_tileserv_url,
  config,
};
